module.exports = __webpack_public_path__ + "static/media/oral.1b014515.svg";